import {useTranslation} from 'react-i18next';
import {Box, Typography} from '@mui/material';
import EventBulletIcon from '@icons/EventBulletIcon';
import prayers from './pray.json';
import {Link} from 'react-router-dom';
import HeaderWithIcons from '@components/app/HeaderWithIcons';

export interface IPrayerCategory {
	name: string,
	children?: IPrayerCategory[],
	texts?: {
		arabic: string,
		verse?: number,
		translate: string,
	}[],
}

// let prayersList: typeof Object[] = prayers
export default function PrayerCategory() {
	const {t} = useTranslation();
	
	return (
		<div className="w-full h-full flex flex-col space-y-2">
			<HeaderWithIcons title={t('pray_service')}/>
			<div className="flex flex-col space-y-2 mx-4">
				{
					prayers instanceof Array &&
					prayers.map(
						(prayer, index) => <Link key={index} to={`/prayer/${index}`}>
							<Box sx={{
								bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : 'background.paper',
								borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : 'grey.700'
							}} className="flex rounded border items-center px-4 h-12">
								<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}}
								            className="grow font-medium">{++index}) {prayer.name}</Typography>
								<EventBulletIcon flip={t('_dir') === 'ltr'}/>
							</Box>
						</Link>
					)
				}
			</div>
		</div>
	);
}
